module.exports = __webpack_public_path__ + "images/pages/for_business/sp/s_icon01_4fc5b47dbdad0278c98c0e60ace48c20.png";